/**
 * Cookie Consent Banner — GDPR/CCPA compliant
 * Blocks PostHog analytics until user gives explicit consent.
 * Stores preference in localStorage.
 */
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const CONSENT_KEY = "gs_cookie_consent";

export function CookieConsentBanner() {
  var [visible, setVisible] = useState(false);

  useEffect(function() {
    var consent = localStorage.getItem(CONSENT_KEY);
    if (!consent) {
      setVisible(true);
    } else if (consent === "accepted") {
      enableAnalytics();
    }
  }, []);

  function enableAnalytics() {
    if (window.posthog && typeof window.posthog.opt_in_capturing === "function") {
      window.posthog.opt_in_capturing();
    }
  }

  function disableAnalytics() {
    if (window.posthog && typeof window.posthog.opt_out_capturing === "function") {
      window.posthog.opt_out_capturing();
    }
  }

  function handleAccept() {
    localStorage.setItem(CONSENT_KEY, "accepted");
    enableAnalytics();
    setVisible(false);
  }

  function handleDecline() {
    localStorage.setItem(CONSENT_KEY, "declined");
    disableAnalytics();
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[9999] bg-[#111] border-t border-white/10 px-6 py-4 shadow-2xl"
      role="dialog"
      aria-label="Cookie consent"
      data-testid="cookie-consent-banner"
    >
      <div className="max-w-[1200px] mx-auto flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <p className="text-white/70 text-sm flex-1 leading-relaxed">
          We use cookies and analytics (PostHog) to improve your experience and understand how our site is used.
          Your data is never sold. See our{" "}
          <Link to="/privacy" className="text-coral hover:text-coral/80 underline">Privacy Policy</Link>
          {" "}for details.
        </p>
        <div className="flex gap-3 shrink-0">
          <Button
            onClick={handleDecline}
            variant="outline"
            className="border-white/20 text-white hover:bg-white/10 text-sm px-5 py-2"
            data-testid="cookie-decline-btn"
          >
            Decline
          </Button>
          <Button
            onClick={handleAccept}
            className="bg-white text-black hover:bg-gray-200 text-sm font-bold px-5 py-2"
            data-testid="cookie-accept-btn"
          >
            Accept Cookies
          </Button>
        </div>
      </div>
    </div>
  );
}
